import React from 'react';
import Icon from '../../../components/openplay/OpenPlayIcon';

const AnalyticsSection = ({ analytics }) => {
  const maxParticipants = Math.max(...analytics.participationTrend.map((d) => d.participants));

  return (
    <div className="space-y-6">
      <h2 className="text-xl font-semibold font-heading text-foreground">통계 분석</h2>

      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
          <div className="flex items-center gap-2 mb-4">
            <Icon name="ChartBarIcon" size={20} className="text-primary" />
            <h3 className="text-lg font-semibold text-foreground">참가자 추이</h3>
          </div>
          <div className="space-y-3">
            {analytics.participationTrend.map((data, index) => {
              const heightPercentage = (data.participants / maxParticipants) * 100;
              return (
                <div key={index} className="flex items-center gap-3">
                  <span className="text-sm text-muted-foreground w-12">{data.month}</span>
                  <div className="flex-1 h-8 bg-muted rounded-lg overflow-hidden relative">
                    <div className="h-full bg-primary transition-smooth" style={{ width: `${heightPercentage}%` }} />
                  </div>
                  <span className="text-sm font-medium text-foreground w-12 text-right">{data.participants}</span>
                </div>
              );
            })}
          </div>
        </div>

        <div className="bg-card rounded-xl border border-border p-6 shadow-elevation-1">
          <div className="flex items-center gap-2 mb-4">
            <Icon name="TrophyIcon" size={20} className="text-primary" />
            <h3 className="text-lg font-semibold text-foreground">인기 종목</h3>
          </div>
          <div className="space-y-3">
            {analytics.popularSports.map((sport, index) => (
              <div key={index}>
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-medium text-foreground">{sport.sport}</span>
                  <span className="text-sm text-muted-foreground">
                    {sport.count}회 ({sport.percentage}%)
                  </span>
                </div>
                <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
                  <div className="h-full bg-primary transition-smooth" style={{ width: `${sport.percentage}%` }} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsSection;
